<template>
    <div>
        <div v-if="isDesktop()" id="e3" class="premier grey lighten-3 border-radius mb-3"
             style="margin-bottom:10%!important">

            <v-expand-transition>
                <div>

                    <v-card class="border-radius policeLato">
                        <v-toolbar color="#ffa409" dark>
                            <v-toolbar-title class="policeLato">Mes Sinistres</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container class="grey lighten-3 border-radius">
                                <v-layout wrap>
                                    <div class="col-sm-12">
                                        <v-data-table :headers="headers" :items="userSinistre"
                                                      class="elevation-1 table table-reponsive small">
                                            <template slot="items" slot-scope="props">
                                                <td>{{ props.item.branche}}</td>
                                                <td>{{ props.item.contrat.numero_police}}</td>
                                                <td>{{ props.item.assureur}}</td>
                                                <td>{{DateFormater(props.item.created)}}</td>
                                                <td class="text-lg-left">
                                                    <ul class="list-boutons">
                                                        <li>
                                                            <v-btn color="grey" @click="setDetailsSinistre(props.item)"
                                                                   flat class="link-btn">
                                                                <v-icon color="grey" class="pr-2">&#xe8f4;</v-icon>
                                                            </v-btn>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>


                    <!--Modal dialog for Details Sinistre list-->
                    <v-fab-transition>
                        <v-dialog v-model="ModalDetailsSinistre" persistent>
                            <v-card class="border-radius">
                                <v-toolbar color="#ffa409">
                                    <v-toolbar-title class="policeLato text-white">
                                        <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #fff">&#xe873;</i>
                                        Détails de Sinistre
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon dark @click="clsoeDetailsPopu()" class="float-lg-right"
                                           style="background: #ffa409">
                                        <v-icon>&#xe5cd;</v-icon>
                                    </v-btn>
                                </v-toolbar>
                                <v-container class="mt-3 border-radius grey lighten-3 scroll">
                                    <div class="justify-center row" v-if="DetailsSinistre!==null">
                                        <div class="border-radius justify-center row ml-5 mr-5 col-sm-11 p-2"
                                             style="border:2px solid #ffa409">
                                            <span class="policeLato ml-2 h2">Évolution à {{progress}}% </span>
                                            <v-progress-linear
                                                    :value="progress"
                                                    :color="color"
                                                    absolute
                                                    height="30">
                                            </v-progress-linear>
                                        </div>

                                        <div class="col-sm-12 p-2">
                                            <div class="col-sm-12 p-1 ml-5">

                                                <div class="col-sm-6" v-if="DetailsSinistre.etat=='Résolu'">
                                                    <span class="ml-1"><i class="fa fa-check-circle"
                                                                          style="font-size:23px;color:green"></i>  Résolu </span>
                                                </div>

                                                <div class="col-sm-6" v-if="DetailsSinistre.etat=='Pris en compte'">
                                                    <span class="ml-1"><i class="fa fa-check-circle"
                                                                          style="font-size:23px;color:yellow"></i>  Pris en compte </span>
                                                </div>

                                                <div class="col-sm-6" v-if="DetailsSinistre.etat=='Non pris en compte'">
                                                    <span class="ml-1"><i class="fa fa-ban"
                                                                          style="font-size:23px;color:orange"></i>  Non pris en compte </span>
                                                </div>

                                            </div>

                                            <div class="col-sm-12 p-1 ml-5">
                                                <div class="col-sm-12" v-if="DetailsSinistre.vueAssureur">
                                                <span>
                                                  <i class="fa fa-eye" style="font-size:23px;color:green"></i> 
                                                  {{DetailsSinistre.vueAssureur}}  
                                                </span>
                                                </div>

                                                <div class="col-sm-12" v-else>
                                                <span>
                                                  <i class="fa fa-eye" style="font-size:23px;color:orange"></i> 
                                                  Pas encore vu par l'assureur 
                                                </span>
                                                </div>
                                            </div>

                                            <div class="col-sm-11 border ml-5 p-1 mt-2 grey lighten-5 border-radius">

                                                <div class="col-sm-12">
                                                    Date de déclaration :
                                                    <span class="font-weight-black">  {{DateFormater(DetailsSinistre.created)}}  </span>
                                                </div>

                                                <div class="col-sm-12 mt-2">
                                                    Mandat :
                                                    <span class="font-weight-black">  {{DetailsSinistre.mandat.toUpperCase()}}  </span>
                                                </div>

                                                <div class="col-sm-12 mt-2">
                                                    Branche :
                                                    <span class="font-weight-black">  {{DetailsSinistre.branche.toUpperCase()}}  </span>
                                                </div>

                                                <div class="col-sm-12 mt-2">
                                                    Assureur :
                                                    <span class="font-weight-black">  {{DetailsSinistre.assureur.toUpperCase()}}  </span>
                                                </div>

                                                <div class="col-sm-12 mt-2">
                                                    <v-textarea readonly outlined name="input-7-4"
                                                                label="Circonstance du Sinistre"
                                                                :value="DetailsSinistre.Circonstance_Sinistres"></v-textarea>
                                                </div>

                                                <div class="col-sm-12 mt-2">
                                                    <v-textarea readonly outlined name="input-7-4"
                                                                label="Détails des Dommages"
                                                                :value="DetailsSinistre.Details_Dommages"></v-textarea>
                                                </div>


                                            </div>

                                        </div>

                                    </div>

                                </v-container>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-fab-transition>
                    <!--End of Modal dialog for Details Sinistre list-->


                </div>
            </v-expand-transition>
            <!--End Modal dialog for Liste Vehicule sinistre declaration-->

        </div>

        <div class="mt-5 justify-content-center row grey lighten-3 ml-5 mr-5" v-if="isMobile()"
             style="margin-bottom:30%">

            <!-- <v-expand-transition>  <div>  </div> </v-expand-transition> -->


            <v-card class="border-radius policeLato mt-3">
                <v-toolbar color="#ffa409" dark>
                    <v-toolbar-title>
                        Mes Sinistres
                    </v-toolbar-title>
                </v-toolbar>
                <v-container class="grey lighten-3 border-radius">
                    <v-data-table :headers="headerMobil" :items="userSinistre"
                                  class="elevation-1 table table-reponsive small">
                        <template slot="items" slot-scope="props">
                            <td>
                                <a href="javascript: void(0)" @click="setDetailsSinistre(props.item)">
                                    {{DateFormater(props.item.created)}}
                                </a>
                            </td>
                            <td @click="setDetailsSinistre(props.item)">
                                <a href="javascript: void(0)" @click="setDetailsSinistre(props.item)">
                                    {{ props.item.branche}}
                                </a>
                            </td>
                        </template>
                    </v-data-table>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>


            <!--Modal dialog for Sinistre list-->
            <!-- <v-fab-transition>
                        <v-dialog v-model="ModalListeSinistre" persistent>

                        </v-dialog>
            </v-fab-transition> -->
            <!--End of Modal dialog for Sinistre list-->


            <!--Modal dialog for Details Sinistre list-->
            <v-fab-transition>
                <v-dialog v-model="ModalDetailsSinistre" width="auto" persistent>
                    <v-card class="border-radius policeLato">
                        <v-toolbar color="#ffa409">
                            <v-toolbar-title class="text-white">
                                <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #fff">&#xe873;</i>
                                Détails de Sinistre
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="clsoeDetailsPopu()" class="float-lg-right"
                                   style="background: #ffa409">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-container class="grey lighten-3 border-radius scroll mt-2">

                            <div class="ml-2 mr-2 row" v-if="DetailsSinistre!==null">

                                <div class=" col-sm-11 p-2" style="border:1px solid grey;border-radius:18px;">
                                    <span class="ml-1 h4"> {{progress}}% </span>
                                    <v-progress-linear :value="progress" :color="color" absolute
                                                       height="30"></v-progress-linear>
                                </div>

                                <div class="col-sm-12 p-2">

                                    <div class="col-sm-12 p-1">

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Résolu'">
                                            <span class="ml-1"><i class="fa fa-check-circle"
                                                                  style="font-size:23px;color:green"></i>  Résolu </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Pris en compte'">
                                            <span class="ml-1"><i class="fa fa-check-circle"
                                                                  style="font-size:23px;color:yellow"></i>  Pris en compte </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Non pris en compte'">
                                            <span class="ml-1"><i class="fa fa-ban"
                                                                  style="font-size:23px;color:orange"></i>  Non pris en compte </span>
                                        </div>

                                    </div>

                                    <div class="col-sm-12 p-1">
                                        <div class="col-sm-12" v-if="DetailsSinistre.vueAssureur">
                                        <span>
                                          <i class="fa fa-eye" style="font-size:23px;color:green"></i> 
                                          {{DetailsSinistre.vueAssureur}}  
                                        </span>
                                        </div>

                                        <div class="col-sm-12" v-else>
                                        <span>
                                          <i class="fa fa-eye" style="font-size:23px;color:orange"></i> 
                                          Pas encore vu par l'assureur 
                                        </span>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 border-radius p-1 mt-2" style="background:white">

                                        <div class="col-sm-12">
                                            Date de déclaration :
                                            <span class="font-weight-black">  {{DateFormater(DetailsSinistre.created)}}  </span>
                                        </div>

                                        <div class="col-sm-12 mt-2">
                                            Mandat :
                                            <span class="font-weight-black">  {{DetailsSinistre.mandat.toUpperCase()}}  </span>
                                        </div>

                                        <div class="col-sm-12 mt-2">
                                            Branche :
                                            <span class="font-weight-black">  {{DetailsSinistre.branche.toUpperCase()}}  </span>
                                        </div>

                                        <div class="col-sm-12 mt-2">
                                            Assureur :
                                            <span class="font-weight-black">  {{DetailsSinistre.assureur.toUpperCase()}}  </span>
                                        </div>

                                        <div class="col-sm-12 mt-2">
                                            <v-textarea readonly outlined name="input-7-4"
                                                        label="Circonstance du Sinistre"
                                                        :value="DetailsSinistre.Circonstance_Sinistres"></v-textarea>
                                        </div>

                                        <div class="col-sm-12 mt-2">
                                            <v-textarea readonly outlined name="input-7-4" label="Details des Dommages"
                                                        :value="DetailsSinistre.Details_Dommages"></v-textarea>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </v-container>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-fab-transition>
            <!--End of Modal dialog for Details Sinistre list-->


        </div>
    </div>

</template>

<script>
    import Api from "./../../services/Api";
    import store from "./../../store/store";
    import dayjs from 'dayjs'

    export default {
        data() {
            return {
                showFormSinistre: false,
                showEtapes: true,
                s1: 0,
                valid: false,
                brancheCheck: null,
                show: false,
                row: null,
                userContrat: [],
                userSinistre: [],
                e1: 0,
                LoadDocumentList: false,
                ModalDetailsSinistre: false,
                DetailsSinistre: null,
                ListeVehicule: [],
                RecapitulatifSinistre: [],
                dialogListeVehicule: false,
                Circonstance_Sinistres: null,
                Details_Dommages: null,
                adresse: null,
                NomPrenom: null,
                heureSurvenance: null,
                dateSurvenance: null,
                vehiculeClient: null,
                usage: null,
                selectedDoc: null,
                displayDoc: null,
                headerMesDoc: [
                    {text: "Type de document", value: "type_document", sortable: false},
                    {text: "Fichier", value: "lien_document", sortable: false},
                    {text: "Date d'ajout", value: "date_upload", sortable: false},
                    {text: "Action", value: "action"}
                ],
                headerMesDocMobile: [
                    {text: "Date d'ajout", value: "date_upload", sortable: false},
                    {text: "Fichier", value: "lien_document", sortable: false},

                ],
                visite: null,
                PartieAdverse: null, //'Non',
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 10000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 10000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                model: null,
                passager: null,
                profession: null,
                policy: null,
                policyAdverse: null,
                validite: null,
                immatricule: null,
                marque: null,
                puissance: null,
                dommage: [],
                assureA: null,
                nameRules: [
                    (v) => !!v || 'Name is required',
                    (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
                ],
                assurRules: [
                    (v) => !!v || "Nom de l'assurance est  obligatoire",
                ],
                immaRules: [
                    (v) => !!v || "le numero d'immatriculation  est  obligatoire",
                ],
                profRules: [
                    (v) => !!v || 'profession est  obligatoire',
                ],
                policyRules: [
                    (v) => !!v || 'N°Police est  obligatoire',
                ],

                constatRules: [
                    (v) => !!v || 'Pv de constat obligatoire',
                ],

                checkbox: true,
                checkbox2: false,
                email: '',
                emailRules: [
                    (v) => !!v || 'E-mail is required',
                    (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],

                dateRules: [
                    (v) => !!v || 'champ obligatoire',

                ],

                date: new Date().toISOString().substr(0, 10),
                menu: false,
                modal: false,
                menu2: false,
                menuDate: false,
                time: null,
                userDocument: [],
                menu3: false,
                ModalListeSinistre: false,
                modal3: false,
                assurance: null,
                mandat: null,
                headers: [
                    {text: "Branche assurance", sortable: false, value: "branche"},
                    {text: "Police Assurance", sortable: false, value: "contrat.numero_police"},
                    {text: "Assureur", sortable: false, value: "assureur"},
                    {text: "Date déclaration", sortable: false, value: "created"},
                    {text: "Actions", sortable: false, value: "action"}
                ],
                headerMobil: [
                    {text: "Date déclarartion", sortable: false, value: "created"},
                    {text: "Branche assurance", sortable: false, value: "branche"},
                ],

                headersVehicules: [
                    {text: "Marque", sortable: false, value: "marque"},
                    {text: "Model", sortable: false, value: "model"},
                ],

                police: null,
                valueProgressBar: 0,
                ListeBranche: []
            }
        },

        computed: {
            progress() {
                return Math.min(100, this.valueProgressBar)
            },
            color() {
                return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
            },
        },

        watch: {
            assurance(val) {
                this.userContrat = [];
                if (val != null && val !== '') {

                    this.checkBranch(val);
                    this.GetUserContarts(val)

                }
            },
            policy(val) {
                if (this.brancheCheck == 'Automobile') {
                    this.getListVehiculeByIdContrat(val)
                }
            }
        },
        methods: {
            showForm() {
                this.showFormSinistre = true,
                    this.showEtapes = false
            },
            submit() {
                this.$refs.form.validate()
            },

            clsoeDetailsPopu() {
                this.ModalDetailsSinistre = false;
                this.valueProgressBar = 0
            },


            setDetailsSinistre(item) {

                if (typeof item.vueAssureur != 'undefined' && typeof item.vueAssureur == 'string') {
                    this.valueProgressBar = 20
                }

                if (item.etat == 'Pris en compte') {
                    this.valueProgressBar = this.valueProgressBar + 30
                }

                if (item.etat == 'Résolu') {
                    this.valueProgressBar = this.valueProgressBar + 50
                }

                this.DetailsSinistre = item;
                this.ModalDetailsSinistre = true

            },

            clear() {
                this.$refs.form.reset()
            },

            checkBranch(id) {

                Api().get('branche/check/' + id)
                    .then(ret => {
                        this.brancheCheck = ret.data.nom
                    })


            },

            //Recuperation des branches d'assurances pour declaration de sinistres
            GetAllBranche() {
                Api().get('branche')
                    .then(response => {
                        this.ListeBranche = response.data
                    })
            },

            //Recuperation des contrats de l'utilisateur pour declaration de sinistre
            GetUserContarts(val) {
                const donnee = {
                    userid: store.state.user._id,
                    brancheid: val
                };
                Api().post('contrat/forsinistre', donnee)
                    .then(response => {
                        for (let index = 0; index < response.data.contrats.length; index++) {
                            this.userContrat.push(response.data.contrats[index])
                        }
                    })
            },

            ListingSinistre() {

                Api().get('sinistre/user/' + store.state.user._id)
                    .then(response => {
                        this.userSinistre = response.data.sinistres
                    });
                this.ModalListeSinistre = true

            },


            /* Retourne true ou false si nous sommes sur un mobile */
            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },


            DateFormater: function (TheDate) {
                if (TheDate) {
                    return dayjs(TheDate).format('DD-MM-YYYY')
                }
            },


            /* Retourne true ou false si nous sommes sur un PC */
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

        },
        mounted() {
            window.scrollTo(0, 0);
            this.ListingSinistre();
            this.ModalListeSinistre = true
        }

    }
</script>
<style>


.borderRadius {
        border-radius: 15px;
        border: 2px solid #ffa409 !important;
    }

    .selectatDesktop {
        border-radius: 15px;
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 680px;
        border: 2px solid lightgrey !important;
    }

    .selectatMobile {
        border-radius: 15px;
        background: url(https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 93%;
        border: 2px solid lightgrey !important;
    }

    .ListStyle li {
        list-style: none
    }

    .file-btn {
        color: #ffa409 !important;
        text-transform: lowercase;
    }

    .border-round {
        border: 1px solid grey;
        border-radius: 10px;
    }

    .form {
        margin-top: -60px;
    }

    .format {
        margin-left: -70px;
        width: 300px;
        margin-top: -50px;
    }

    .premier {
        max-width: 1200px;
        margin: auto;
        margin-top: 100px;
    }

    .detail {
        color: grey;
        margin-left: 80px;
    }

    .mobile {
        margin-left: 2px;
        margin-right: 2px;
        margin-bottom: 10px;
    }

    .dom {
        color: grey;
        margin-right: 0px;
        margin-top: 20px;
    }

    .file {
        width: 500px;
        margin-bottom: 50px;
        margin-left: 16%;
    }

    .list-boutons li {
        text-decoration: none !important;
        list-style: none;
    }


    .list-boutons li .link-btn:hover {
        text-decoration: none !important;
        color: white !important;
    }


    .assuraf-text-color {
        color: #ffa409;
    }


    .sinistre {
        margin-left: 150px;
        margin-top: 10px;
        margin-bottom: 50px;


    }


    /* ==================CSS SINISTRE FORM MOBILE============== */

    .border-radius {
        border-radius: 20px !important
    }

    .georgia {
        font-family: georgia !important;
    }

    .policeLato {
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }
</style>
